<template>
  <div>
    <event-details :eventOptions="eventOptions" v-if="getterPopupName === 'EventDetails'" />

    <h5 v-if="pastEventsPage">
      <i class="fa fa-angle-right" />
      Last 30 days
    </h5>

    <div class="table-head" v-if="isDesktop()">
      <p>Product</p>
      <p>Severity</p>
      <p>Duration</p>
    </div>

    <div class="table-body card-list">
      <div class="table-row" v-for="(data, index) in events" :key="index"
          @click="showDetails(data)">
        <p>
          <b v-if="!isDesktop()">Product:</b>
          <span>{{data.service}} - {{data.module}}</span>
        </p>
        <p class="mt-right">
          <b v-if="!isDesktop()">Severity:</b>
          <span>{{data.severity}}</span>
        </p>
        <p class="mt-col-span2">
          <span v-for="(time, timeIndex) in startEnd(data.start_time, data.end_time)"
                :key="timeIndex">
            <b>{{time.title}}</b>:
            {{time.value}}
          </span>
        </p>
      </div>
    </div>

    <table-loader v-if="!paginate.data_added || events.length < paginate.total" />
    <div v-else-if="events.length === 0 && paginate.data_added" class="empty-list">
      <p>No events found</p>
    </div>
  </div>
</template>

<script>
import TableLoader from '@/components/global/TableLoader'
import EventDetails from '@/components/Status/Details'

import ApiServices from '@/services/api/serviceStatus'
import moment from 'moment'
import { onScroll, openPopup } from '@/utils/helpers'
import { mapMutations, mapGetters } from 'vuex'

export default {
  name: 'EventsList',
  components: { TableLoader, EventDetails },
  data () {
    return {
      events: [],
      paginate: {},
      pastEventsPage: true,
      eventOptions: {},
      dateFormat: 'DD-MMM-YYYY, hh:mm a'
    }
  },
  watch: {
    '$route': {
      handler: 'populateData',
      immediate: true
    }
  },
  computed: {
    ...mapGetters(['getterPopupName'])
  },
  methods: {
    moment,
    onScroll,
    openPopup,
    ...mapMutations(['SET_UPCOMING_EVENTS_COUNT']),
    populateData () {
      this.pastEventsPage = this.$route.name === 'PastEvents'
      this.events = []
      this.paginate = {}
      this.eventsList()
    },
    eventsList (start) {
      this.fetchRecords(start).then(() => {
        this.onScroll(this.paginate, this.eventsList)
      })
    },
    fetchRecords (start) {
      return new Promise(resolve => {
        let params = {}
        if (start) {
          params['offset'] = start
        }

        ApiServices[this.pastEventsPage ? 'pastEvents' : 'upcomingEvents'](params).then(response => {
          this.handleResponse(response, start)
          resolve()
        })
      })
    },
    handleResponse (response, start) {
      if (start) {
        this.events.push(...response.data.events)
      } else {
        let data = response.data
        this.pastEventsPage ? this.SET_UPCOMING_EVENTS_COUNT(data.upcoming_events_total) : this.SET_UPCOMING_EVENTS_COUNT(data.total)
        this.events = data.events

        this.paginate['start'] = 0
        this.paginate['page_size'] = data.page_size
        this.paginate['total'] = data.total
        this.paginate['data_added'] = true
      }
    },
    startEnd (start, end) {
      let obj = [{
        title: 'From',
        value: moment(start).format(this.dateFormat)
      }]
      if (end) {
        obj.push({
          title: 'To',
          value: moment(end).format(this.dateFormat)
        })
      }
      return obj
    },
    showDetails (data) {
      this.openPopup('EventDetails')
      this.eventOptions = {
        ...data
      }
    }
  }
}
</script>

<style scoped lang="scss">
  @import '@/assets/scss/settingsTable.scss';

  h5 {
    text-align: left;
    font-size: 13px;
    font-style: italic;
  }

  .empty-list {
    border-radius: 15px;
    padding: 20px 10px;
    margin-top: 15px;

    p {
      font-size: 15px;
    }
  }

  .desktop {
    h5 {
      margin-bottom: 10px;

      i {
        color: $primary;
      }
    }

    .table-head, .table-row {
      @include custom-grid-col(30% 20% auto !important, 10px);
    }

    .table-row {
      span {
        display: block;
      }
    }

    .empty-list {
      border: 2px solid $grey-outline;
    }
  }

  .mobile,.tablet {
    .table-row {
      grid-template-columns: repeat(2, 1fr);

      p {
        &.mt-col-span2 {
          grid-column: 1 / span 2;

          span {
            padding: 4px 0;
            display: block;
          }
        }
      }
    }

    .empty-list {
      background: $white;
      box-shadow: $card-shadow;
    }
  }
</style>
